$(document).ready(function(){
    
   $('.home-section--title').click(function() {
     var data_id = $(this).attr("data-id");
      //console.log('data_iddata_iddata_id --- >> '+data_id);
      $('.home-section--title').removeClass("active");
      $(this).addClass("active");
      $('.tab_sec').addClass("ecom_hidden");
      $('.'+data_id).removeClass("ecom_hidden");
     
      //console.log('dddddddddddddddddddd');
   });
  
  });
//    $('h2.ecom_first_title').click(function() {
//     $('.home-section--title').removeClass("active");
//     $(this).addClass("active");
//     $('.ecom_first').css("display","block");
//     $('.ecom_second').css("display","none");
//   })
  
//   $('h2.ecom_first_title').click(function() {
//     $('.home-section--title').removeClass("active");
//     $(this).addClass("active");
//     $('.ecom_first').css("display","block");
//     $('.ecom_second').css("display","none");
//   })
//   $('h2.ecom_second_title').click(function() {
//     $('.home-section--title').removeClass("active");
//     $(this).addClass("active");
//     $('.ecom_second').css("display","block");
//     $('.ecom_first').css("display","none");
//   })